module.exports = __webpack_public_path__ + "img/prispartner-logo.4aa0c7d1.png";